import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { reactiveOmit } from '@vueuse/core';
    import { X } from 'lucide-vue-next';
    import {
        DialogClose,
        DialogContent,
        type DialogContentEmits,
        type DialogContentProps,
        DialogPortal,
        useForwardPropsEmits,
    } from 'reka-ui';
    import SheetOverlay from './SheetOverlay.vue';

    interface SheetContentProps extends DialogContentProps {
        class?: HTMLAttributes['class'];
        side?: 'top' | 'right' | 'bottom' | 'left';
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'SheetContent',
  props: {
    class: {},
    side: { default: 'right' },
    forceMount: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(__props: any, { emit: __emit }) {

    

    const props = __props;
    const emits = __emit;

    const delegatedProps = reactiveOmit(props, 'class', 'side');

    const forwarded = useForwardPropsEmits(delegatedProps, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogPortal), null, {
    default: _withCtx(() => [
      _createVNode(SheetOverlay),
      _createVNode(_unref(DialogContent), _mergeProps({
        "data-slot": "sheet-content",
        class: 
                _unref(cn)(
                    'bg-background data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 flex flex-col gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500',
                    _ctx.side === 'right' &&
                        'data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right inset-y-0 right-0 h-full w-3/4 border-l sm:max-w-sm',
                    _ctx.side === 'left' &&
                        'data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left inset-y-0 left-0 h-full w-3/4 sm:max-w-sm',
                    _ctx.side === 'top' &&
                        'data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top inset-x-0 top-0 h-auto border-b',
                    _ctx.side === 'bottom' &&
                        'data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom inset-x-0 bottom-0 h-auto border-t',
                    props.class,
                )
            
      }, { ..._unref(forwarded), ..._ctx.$attrs }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(_unref(DialogClose), { class: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none" }, {
            default: _withCtx(() => [
              _createVNode(_unref(X), { class: "size-4" }),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Close", -1))
            ]),
            _: 1,
            __: [0]
          })
        ]),
        _: 3
      }, 16, ["class"])
    ]),
    _: 3
  }))
}
}

})